import React, { useContext, useEffect, useState } from 'react';
import { IntegrationMetadata, MerchantIntegration } from '@anticatrade/shared';
import { AppContext, appContext } from '../../../context/AppContext';

const useIntegrations = () => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [available, setAvailable] = useState<IntegrationMetadata[]>([]);
	const [installed, setInstalled] = useState<MerchantIntegration[]>([]);

	const { api, handleError, merchant, redirect } = useContext(
		appContext as React.Context<AppContext>,
	);

	const load = async () => {
		try {
			const [availableRes, installedRes] = await Promise.all([
				api.integrations(),
				api.merchantIntegrations(),
			]);
			setAvailable(availableRes.integrations);
			setInstalled(installedRes.integrations);
		} catch (err) {
			handleError(err as Error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (merchant == null) {
			return;
		}
		if (!merchant.features?.includes('integrations')) {
			redirect('products');
			return;
		}
		load();
	}, [merchant]);

	const removeIntegration = async (id: number) => {
		await api.deleteMerchantIntegration(id);
		await load();
	};

	return {
		isLoading,
		available,
		installed,
		removeIntegration,
	};
};

export { useIntegrations };
